export const LOAD_COMPLIANCE_REVIEW_DATA = 'complianceReviewWizard/LOAD_COMPLIANCE_REVIEW_DATA';
export const UPDATE_COMPLIANCE_REVIEW = 'complianceReviewWizard/UPDATE_COMPLIANCE_REVIEW';
export const RESET_COMMENT = 'complianceReviewWizard/RESET_COMMENT';
